function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { CheckBox, Layout } from "../../../native";
import { StyleSheet } from 'react-native';
import * as R from 'unitx/ramda';
import { useFormContext } from "../FormContext";

const selectValue = (value, selected, all) => {
  const at = all.indexOf(value);
  const updated = selected.slice(0, at).concat(value, selected.slice(at)); // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order

  return updated.sort((a, b) => all.indexOf(a) - all.indexOf(b));
};

const deselectValue = (value, selected) => selected.filter(v => v !== value);

const CheckboxesWidget = ({
  // schema,
  // label,
  disabled,
  options,
  value,
  readonly,
  onChange,
  formContext
}) => {
  const {
    enumOptions,
    enumDisabled
  } = options;

  const _onChange = option => checked => {
    const all = enumOptions.map(({
      value: v
    }) => v);
    return R.ifElse(R.isTrue, () => onChange(selectValue(option.value, value, all)), () => onChange(deselectValue(option.value, value)))(checked);
  };

  const {
    mapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(Layout, _extends({}, mapping.fieldContainer, {
    style: [mapping.fieldContainer.style, styles.container]
  }), enumOptions.map((option, index) => {
    const checked = value.indexOf(option.value) !== -1;
    const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
    return /*#__PURE__*/React.createElement(CheckBox, _extends({
      key: index
    }, mapping.checkbox, {
      style: [mapping.checkbox.style],
      onChange: _onChange(option),
      checked: checked,
      disabled: disabled || itemDisabled || readonly
    }), option.label);
  }));
};

const styles = StyleSheet.create({
  container: {}
});
export default CheckboxesWidget;